var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F9F7FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4053_35637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 15.1776 15.1776 8 24 8C27.5631 8 30.9356 9.14636 33.753 11.3152L30.0349 16.1451C28.2929 14.8041 26.206 14.0952 24 14.0952C18.5385 14.0952 14.0952 18.5385 14.0952 24C14.0952 29.4615 18.5385 33.9048 24 33.9048C28.3988 33.9048 32.1368 31.0228 33.4251 27.0476H24V20.9524H40V24C40 32.8224 32.8224 40 24 40C15.1776 40 8 32.8224 8 24Z",
    fill: "#1B4458",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4053_35637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7d9af78ebc6588a13da75a58ef81043f.svg";
export { ForwardRef as ReactComponent };